export default __webpack_public_path__ + "static/media/sticker-C.13247e0c.png";